export const increaseTime = state => {

    setTimeout(() => {
        state.callTime++;
        if (state.onCall)
            increaseTime(state);
    }, 1000)
};
